import styled, { css } from "styled-components";

const FormGroup = styled.div`
  text-align: left;
  margin-bottom: 30px;

  /* If flex provided */
  ${(props) =>
    props.flex &&
    css`
      display: flex;
      align-items: center;
      justify-content: space-between;
    `}

  & label,
  .forgot-link {
    display: inline-block;
    margin-bottom: 8px;
  }

  & .forgot-link {
    text-align: right;
    float: right;
    margin-top: 8px;
  }

  & * {
    clear: both;
  }

  & .input-error {
    color: red;
    font-size: 15px;
    margin-top: 5px;
    display: inline-block;
  }

  & button {
    height: 62px;
    padding: 12px 0;
    font-family: Noto Sans;
    width: 100%;
    border: none;
    background-color: ${(props) => props.theme.accentColor};
    color: white;
    font-weight: 600;
    font-size: 22px;
    line-height: 27px;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.2s ease-in-out;
    box-shadow: 0px 1px 2px -1px rgba(17, 12, 34, 0.08);
    text-transform: capitalize;
  }
  & button:disabled {
    background-color: #e6e6e6;
    color: #b3b3b3;
    cursor: wait;
  }

  & button:hover {
    opacity: 0.9;
  }
`;

export default FormGroup;
